export default function IndustrySectorsSection() {
  const sectors = [
    {
      title: 'Energy Infrastructure',
      description: 'Offshore wind installations, oil and gas facilities, power generation equipment, subsea structures.',
    },
    {
      title: 'Industrial Manufacturing',
      description: 'Pressure equipment manufacturers, steel fabrication facilities, heavy equipment suppliers, process equipment manufacturers.',
    },
    {
      title: 'EPC and Construction',
      description: 'Engineering, procurement, and construction contractors requiring supply chain verification and sub-tier surveillance.',
    },
    {
      title: 'OEM Supply Chains',
      description: 'Original equipment manufacturers requiring supplier qualification verification and manufacturing oversight.',
    },
  ];

  return (
    <section className="py-28 px-8 bg-light-section">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-light-border rounded-full mb-6">
            <span className="text-industrial-steel text-xs font-medium tracking-[0.12em] uppercase">
              Industry Sectors
            </span>
          </div>
          <h2 className="font-serif text-dark-primary text-4xl leading-tight mb-6">
            Target Sectors
          </h2>
        </div>

        {/* Sectors Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {sectors.map((sector) => (
            <div key={sector.title} className="bg-white border border-light-border rounded-lg p-8">
              <h3 className="text-dark-primary text-base font-semibold mb-4 tracking-wide">
                {sector.title}
              </h3>
              <p className="text-industrial-steel text-sm leading-[1.75]">
                {sector.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}